import {
  Shimmer, ShimmerAnimation, ShimmerColors, ShimmerShapes,
} from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const ShimmerBlock = ({ width, height, radius }) => (
  <Shimmer
    shape={ShimmerShapes.RECTANGLE}
    color={ShimmerColors.gray100}
    animation={ShimmerAnimation.SHIMMER}
    width={width}
    height={height}
    radius={radius}
  />
);

ShimmerBlock.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  radius: PropTypes.string,
};

ShimmerBlock.defaultProps = {
  radius: '4px',
};

export default ShimmerBlock;
